import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import MemoryRecord from "models/view-models/memories/memory-record";
import { ConfirmationModal } from "molecules/modals/confirmation-modal";
import React, { useState } from "react";
import DateUtils from "utilities/date-utils";
import useModalActions from "utilities/hooks/use-modal-actions";
import { t } from "utilities/localization-utils";
import MemoriesService from "utilities/services/memories/memories-service";

interface ChatMemoryItemProps {
    memory: MemoryRecord;
    onSuccess?: () => void;
    onError?: () => void;
}

const CSS_CLASS_NAME = "c-chat-memory-item";

const ChatMemoryItem = ({
    memory,
    onSuccess,
    onError,
}: ChatMemoryItemProps) => {
    const { isOpen, handleClose, handleOpen } = useModalActions();
    const [isDeleting, setIsDeleting] = useState(false);
    const handleDeleteMemory = async () => {
        try {
            setIsDeleting(true);
            await MemoriesService.delete(memory.id!);
            onSuccess?.();
        } catch (e) {
            console.error(e);
            onError?.();
        } finally {
            setIsDeleting(false);
            handleClose();
        }
    };
    return (
        <>
            <li className={CSS_CLASS_NAME}>
                <div className={`${CSS_CLASS_NAME}__memory`}>
                    <span className={`${CSS_CLASS_NAME}__memory-content`}>
                        {memory.content}
                    </span>
                    <span className={`${CSS_CLASS_NAME}__memory-date`}>
                        <Icon type={Icons.Clock} />
                        {`${t("saved")} ${DateUtils.formatCustomDate(memory.createdOn, "LL")}`}
                    </span>
                </div>
                <div className={`${CSS_CLASS_NAME}__action`}>
                    <Button
                        style={ButtonStyles.TertiaryAlt}
                        onClick={handleOpen}>
                        <span className="sr-only">{t("delete")}</span>

                        <Icon type={Icons.Trashcan} />
                    </Button>
                </div>
            </li>
            <ConfirmationModal
                isLoading={isDeleting}
                isVisible={isOpen}
                message={t("chat-memory-item--delete-confirmation-message")}
                onCancel={handleClose}
                onConfirm={handleDeleteMemory}
            />
        </>
    );
};

export default ChatMemoryItem;
